import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export function Breadcrumbs({ items }) {
  return (
    <nav data-testid="breadcrumbs" className="flex items-center gap-1.5 text-sm flex-wrap">
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <span key={it.to || it.label} className="flex items-center gap-1.5">
            {it.to && !last ? (
              <Link
                to={it.to}
                className="font-medium text-muted-foreground hover:text-foreground transition-colors"
              >
                {it.label}
              </Link>
            ) : (
              <span className={last ? "font-semibold text-foreground" : "text-muted-foreground"}>
                {it.label}
              </span>
            )}
            {!last && <ChevronRight size={14} className="text-muted-foreground/50" />}
          </span>
        );
      })}
    </nav>
  );
}
